













































































































































































































import Vue, { PropType } from 'vue';
// import { BrandData } from '@/modules/exhibitor/brand';

import {
  // Option,
  BrandData,
  OptionValue,
  options,
} from 'mostra';
// import {
//   Option,
//   options,
// } from '@/modules/options';
// import {
//   titleFontOptions,
//   bodyFontOptions,
//   contactButtonShapeOptions,
//   Option,
// } from '@/modules/options';

interface DataType {
  titleFontOptions: OptionValue[];
  bodyFontOptions: OptionValue[];
  contactButtonShapeOptions: OptionValue[];
}

export default Vue.extend({
  name: 'GBrandDesignForm',
  props: {
    brand: {
      type: Object as PropType<BrandData>,
    },
  },
  data(): DataType {
    return {
      titleFontOptions: options.titleFontOptions,
      bodyFontOptions: options.bodyFontOptions,
      contactButtonShapeOptions: options.contactButtonShapeOptions,
    };
  },
  methods: {
    onChangeTitleFont(val: number) {
      this.brand.design.title.font = val;
    },
    onChangeBodyFont(val: number) {
      this.brand.design.body.font = val;
    },
    onChangeContactButtonShape(val: number) {
      this.brand.design.contact.shape = val;
    },
  },
});
